import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PageHeader } from "@/components/StatusBadge";
import { RecordForm } from "@/components/records/RecordForm";

export default function RecordNew() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [saving, setSaving] = useState(false);
  const save = async (body) => {
    setSaving(true);
    try {
      const r = await api.post("/records", body);
      toast.success(`Draft saved as ${r.data.ref_no}`);
      nav(`/records/${r.data.record_id}`);
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  return (
    <div>
      <PageHeader eyebrow="Registry" title="Register a record" testid="record-new-title" />
      <RecordForm mode="create" initial={{ record_type: params.get("type") || undefined, office: params.get("office") || undefined }} onSave={save} saving={saving} onCancel={() => nav(-1)} />
    </div>
  );
}
